import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getJiraOrgSettings, saveJiraOrgSettings } from '../../services/jiraService';
import { addNotification } from '../../store/slices/uiSlice';

const AdminJiraSettingsPanel = () => {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);
  const [siteUrl, setSiteUrl] = useState('');
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  const load = async () => {
    try {
      setLoading(true);
      const data = await getJiraOrgSettings();
      setSiteUrl(data.siteUrl || '');
    } catch (error) {
      dispatch(addNotification({
        type: 'error',
        message: error.message || 'Failed to load Jira settings',
      }));
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, []);

  const handleSave = async (event) => {
    event.preventDefault();
    setSaving(true);
    try {
      const data = await saveJiraOrgSettings(siteUrl);
      setSiteUrl(data.siteUrl || '');
      dispatch(addNotification({
        type: 'success',
        message: data.configured
          ? 'Organization Jira URL saved. Members can connect with email and API token.'
          : 'Organization Jira URL cleared.',
      }));
    } catch (error) {
      dispatch(addNotification({
        type: 'error',
        message: error.message || 'Failed to save Jira URL',
      }));
    } finally {
      setSaving(false);
    }
  };

  if (user?.role !== 'ORG_ADMIN' && user?.role !== 'ADMIN') {
    return null;
  }

  return (
    <div className="bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700 p-6">
      <h2 className="text-xl font-semibold text-gray-900 dark:text-white">Organization Jira</h2>
      <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">
        Set the company Jira site once. Members then only enter their Jira email and API token to load assigned tickets.
      </p>
      {loading ? (
        <p className="mt-4 text-sm text-gray-500">Loading…</p>
      ) : (
        <form onSubmit={handleSave} className="mt-5 space-y-3 max-w-xl">
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
            Jira site URL
          </label>
          <input
            type="url"
            value={siteUrl}
            onChange={(e) => setSiteUrl(e.target.value)}
            placeholder="https://your-company.atlassian.net"
            className="w-full rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-900 px-3 py-2 text-sm text-gray-900 dark:text-white"
          />
          <p className="text-xs text-gray-500 dark:text-gray-400">
            Example: https://techelliptica.atlassian.net
          </p>
          <button
            type="submit"
            disabled={saving}
            className="px-4 py-2 text-sm font-semibold rounded-lg bg-primary-600 text-white hover:bg-primary-700 disabled:opacity-50"
          >
            {saving ? 'Saving…' : 'Save Jira URL'}
          </button>
        </form>
      )}
    </div>
  );
};

export default AdminJiraSettingsPanel;
